<template>
  <general-layout class="preview-box">
    <template #header>
      <east-operate>
        <template #left>
          <iframe :src="infoSrc" frameborder="0" class="frame-info"></iframe>
        </template>
        <template #right>
          <el-input
            v-model="keyword"
            placeholder="请输入关键字"
            style="width: 320px"
          >
            <el-select
              v-model="scope"
              v-if="!mail"
              style="width: 104px"
              slot="prepend"
            >
              <el-option value="all" label="查找范围"></el-option>
              <el-option value="maillist" label="列表名称"></el-option>
              <el-option value="forward" label="列表成员"></el-option>
            </el-select>
          </el-input>
        </template>
      </east-operate>
    </template>
    <div class="content-box">
      <general-layout ref="maillistBox" class="maillist-box" v-if="!mail">
        <layui-table
          :data="maillistTableDataPage"
          :row-class-name="tableRowClassName"
          @row-click="rowClick"
          empty-text="未找到邮件列表"
        >
          <layui-table-column label="列表地址" min-width="200" align="center">
            <template slot-scope="scope">
              <keyword-mail :keyword="scope !== `forward` && keyword">
                {{ scope.row.mail }}
              </keyword-mail>
            </template>
          </layui-table-column>
          <layui-table-column
            prop="nickname"
            label="列表名称"
            min-width="150"
          ></layui-table-column>
          <layui-table-column label="成员数量" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.row.forwardList.length }}
            </template>
          </layui-table-column>
          <layui-table-column
            prop="error"
            label="异常信息"
            min-width="120"
          ></layui-table-column>
        </layui-table>
        <template #footer>
          <el-pagination
            @size-change="maillistPageSizeChange"
            @current-change="maillistPageChange"
            :current-page="maillistPage"
            :page-sizes="$page.sizes"
            :page-size="maillistPageSize"
            layout="total, sizes, prev, pager, next"
            :total="maillistTableDataFilter.length"
          >
          </el-pagination>
        </template>
      </general-layout>
      <general-layout ref="forwardBox" class="forward-box">
        <layui-table :data="forwardTableDataPage" empty-text="未找到有效成员">
          <layui-table-column
            :label="forwardLabel"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <keyword-mail :keyword="scope !== `maillist` && keyword">
                {{ scope.row }}
              </keyword-mail>
            </template>
          </layui-table-column>
          <layui-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click.stop="showForward(scope.row)"
                >查看详情</el-button
              >
            </template>
          </layui-table-column>
        </layui-table>
        <template #footer>
          <el-pagination
            @size-change="forwardPageSizeChange"
            @current-change="forwardPageChange"
            :current-page="forwardPage"
            :page-sizes="$page.sizes"
            :page-size="forwardPageSize"
            layout="total, sizes, prev, pager, next"
            :total="forwardTableDataFilter.length"
          >
          </el-pagination>
          <el-dialog
            title="成员详细信息"
            :visible.sync="detailVisible"
            width="800px"
            append-to-body
          >
            <div v-if="detailVisible">
              <entry-editor :dn="detailDn" :isAdd="false"></entry-editor>
            </div>
          </el-dialog>
        </template>
      </general-layout>
    </div>
  </general-layout>
</template>

<script>
import MAILLIST from "@/api/sync/maillist";
import EntryEditor from "@/pages/ldap/entry-editor";

export default {
  data() {
    return {
      infoSrc: process.env.VUE_APP_BASE_API + "sync/maillist/info",
      maillistCache: null,
      selectedMaillist: null,
      scope: this.$route.query.mail ? "forward" : "all",
      keyword: "",
      maillistPage: 1,
      maillistPageSize: this.$page.size,
      forwardPage: 1,
      forwardPageSize: this.$page.size,
      isForwardPopShow: false,
      detailVisible: false,
      detailDn: null
    };
  },
  computed: {
    mail: vm => vm.$route.query.mail,
    forwardLabel() {
      let [total, mail] = this.selectedMaillist
        ? [
            this.selectedMaillist.forwardList.length,
            this.selectedMaillist.mail + " "
          ]
        : [0, ""];
      let number =
        this.keyword && (this.scope === "all" || this.scope === "forward")
          ? this.forwardTableDataFilter.length + "/" + total
          : total;
      return `${mail}成员列表(${number})`;
    },
    maillistTableData() {
      return this.maillistCache ? this.maillistCache.list : [];
    },
    maillistTableDataFilter() {
      if (this.keyword) {
        let keyword = this.keyword.toLowerCase();
        return this.maillistTableData.filter(maillist => {
          let maillistFlag = true,
            forwardFlag = true;
          if (this.scope === "all" || this.scope === "maillist") {
            maillistFlag = maillist.mail.toLowerCase().includes(keyword);
          }
          if (this.scope === "all" || this.scope === "forward") {
            forwardFlag = maillist.forwardList.some(forward =>
              forward.toLowerCase().includes(keyword)
            );
          }
          return this.scope === "all"
            ? maillistFlag || forwardFlag
            : maillistFlag && forwardFlag;
        });
      }
      return this.maillistTableData;
    },
    maillistTableDataPage() {
      if (this.maillistTableDataFilter.length) {
        return this.maillistTableDataFilter.slice(
          (this.maillistPage - 1) * this.maillistPageSize,
          Math.min(
            this.maillistPage * this.maillistPageSize,
            this.maillistTableDataFilter.length
          )
        );
      } else {
        return [];
      }
    },
    forwardTableData() {
      return this.selectedMaillist ? this.selectedMaillist.forwardList : [];
    },
    forwardTableDataFilter() {
      if (this.keyword && (this.scope === "all" || this.scope === "forward")) {
        let keyword = this.keyword.toLowerCase();
        return this.forwardTableData.filter(function(forward) {
          return forward.toLowerCase().includes(keyword);
        });
      }
      return this.forwardTableData;
    },
    forwardTableDataPage() {
      if (this.forwardTableDataFilter.length) {
        return this.forwardTableDataFilter.slice(
          (this.forwardPage - 1) * this.forwardPageSize,
          Math.min(
            this.forwardPage * this.forwardPageSize,
            this.forwardTableDataFilter.length
          )
        );
      } else {
        return [];
      }
    }
  },
  created() {
    this.fetchData();
    window.aaaaa = this.fetchData;
    window.addEventListener("message", this.handleMessage);
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    async fetchData() {
      let response = await MAILLIST.CACHE({ mail: this.mail });
      if (response.data.state) {
        this.setMaillistCache(response.data.cache);
      }
    },
    handleMessage(event) {
      if (event.data.configHash) {
        this.fetchData();
      }
    },
    setMaillistCache(cache) {
      this.maillistCache = cache;
      if (this.maillistCache && this.maillistCache.list.length) {
        // 邮件列表锁定状态
        if (this.mail) {
          let selectedMail = null;
          this.maillistCache.list.forEach(maillist => {
            if (maillist.mail === this.mail) {
              selectedMail = maillist;
            }
          });
          this.selectedMaillist = selectedMail;
          // 邮件列表可选状态
        } else {
          let mail = this.selectedMaillist && this.selectedMaillist.mail;
          if (mail) {
            this.maillistCache.list.forEach(
              function(maillist) {
                if (maillist.mail === mail) {
                  this.selectedMaillist = maillist;
                }
              }.bind(this)
            );
          }
          if (!this.selectedMaillist) {
            this.selectedMaillist = this.maillistCache.list[0];
          }
        }
      } else {
        this.selectedMaillist = null;
      }
    },
    tableRowClassName({ row }) {
      if (this.selectedMaillist) {
        if (row.mail === this.selectedMaillist.mail) {
          return "selected-row";
        }
        return "";
      }
    },
    rowClick(row) {
      this.selectedMaillist = row;
      this.forwardPage = 1;
    },
    maillistPageChange(page) {
      this.maillistPage = page;
    },
    maillistPageSizeChange(pageSize) {
      this.maillistPageSize = pageSize;
      this.maillistPage = 1;
    },
    forwardPageChange(page) {
      this.forwardPage = page;
    },
    forwardPageSizeChange(pageSize) {
      this.forwardPageSize = pageSize;
      this.forwardPage = 1;
    },
    async showForward(forward) {
      if (!this.isForwardPopShow) {
        this.isForwardPopShow = true;
        try {
          const response = await MAILLIST.GET_ENTRY_BY_MAIL({ mail: forward });
          if (response.data.state) {
            if (response.data.entry) {
              this.detailDn = response.data.entry.dn;
              this.detailVisible = true;
              // east.showPop({
              //   src: "/sync/ldap/EntryEdit?hex=" + toHex(data.entry.dn),
              //   width: 1000,
              //   height: 800,
              //   title: forward + " 详细信息"
              // });
            } else {
              this.$message.info("未能查询到该成员原始节点信息。");
            }
          } else {
            this.$message.error("详细信息查询失败。");
          }
        } finally {
          this.isForwardPopShow = false;
        }
      } else {
        this.$message.info("详细信息查询中，请稍后...");
      }
    }
  },
  watch: {
    maillistTableDataPage(newList) {
      if (!this.mail) {
        if (this.maillistTableDataFilter.length) {
          if (
            !this.selectedMaillist ||
            !newList.some(
              maillist => maillist.mail === this.selectedMaillist.mail
            )
          ) {
            this.selectedMaillist = newList[0];
          }
        } else {
          this.selectedMaillist = null;
        }
      }
    },
    keyword(newWord, oldWord) {
      if (newWord !== oldWord) {
        this.maillistPage = 1;
        this.forwardPage = 1;
      }
    },
    forwardLabel() {
      let forwardLabel = this.$refs.forwardBox?.$el?.querySelector(
        ".layui-table-header th:first-child span"
      );
      if (forwardLabel) {
        forwardLabel.innerHTML = this.forwardLabel;
      }
    }
  },
  components: {
    EntryEditor,
    "keyword-mail": {
      props: {
        keyword: { type: String }
      },
      render(h) {
        let mail = this.$slots.default[0].text;
        if (this.keyword) {
          let keywordLower = this.keyword.toLowerCase();
          let mailLower = mail.toLowerCase();
          let length = keywordLower.length;
          let content = [];
          let endIndex = 0,
            index = 0;
          while ((index = mailLower.indexOf(keywordLower, endIndex)) !== -1) {
            content.push(h("span", mail.slice(endIndex, index)));
            content.push(h("b", mail.slice(index, index + length)));
            endIndex = index + length;
          }
          content.push(h("span", mail.slice(endIndex)));
          return h("span", { class: "keyword-mail" }, content);
        } else {
          return h("span", mail);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.preview-box {
  &::v-deep > .el-main {
    overflow: hidden;
  }
  ::v-deep .keyword-mail {
    > b {
      color: #ee0000;
    }
  }
}
.content-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  > .general-layout {
    padding: 0;
  }
}
.el-pagination::v-deep {
  background: #ffffff;
  .el-pagination__total {
    margin-right: 4px;
  }
  .el-pagination__sizes {
    margin-right: 0;
  }
  .btn-prev {
    padding-right: 2px;
  }
  .btn-next {
    padding-left: 2px;
  }
  .el-pager li {
    min-width: 26px;
  }
}
.maillist-box {
  ::v-deep .layui-border-box {
    border-right: none;
  }
  ::v-deep .el-pagination {
    text-align: left;
  }
  ::v-deep .selected-row {
    background-color: #eeeeee;
  }
}
.forward-box {
  flex: none;
  width: 480px;
  &:only-child {
    flex: auto;
  }
}
.frame-info {
  height: 32px;
  width: 450px;
  vertical-align: middle;
}
</style>
